export const PAGINATED_SLUG_SUFFIX = '-paginated';

export function appendPaginatedSlugSuffix(slug: string): string {
  return `${slug}${PAGINATED_SLUG_SUFFIX}`;
}

export function isPaginated(slug: string): boolean {
  return slug.includes(PAGINATED_SLUG_SUFFIX);
}
